import { atom } from 'infrastructure/state/jotai.wrapper'

export const gradeAtom = atom(0)

export const gradeTagAtom = atom('')
